import { useEffect, useState } from "react";

export default function CopyButton({
  value,
  label = "Copy",
  subtle = false,
}: {
  value: string;
  label?: string;
  subtle?: boolean;
}) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 1600);
    return () => clearTimeout(t);
  }, [copied]);

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch {
      // Clipboard API needs a secure context and permission. Fall back to the old way
      // rather than leaving the user with a button that silently does nothing.
      const ta = document.createElement("textarea");
      ta.value = value;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      setCopied(true);
    }
  }

  return (
    <button
      className={`btn btn-sm ${subtle ? "btn-subtle" : "btn-ghost"} ${copied ? "btn-copied" : ""}`}
      onClick={copy}
      type="button"
    >
      {copied ? "Copied" : label}
    </button>
  );
}
